import { getAppState } from "../state";
import { getAllActiveSubscriptionsDeepQuery, getUserPayments } from "../services/billingService";
import { getPaymentMethod } from "../services/paymentService";
import { getAddOnByName } from "./subscriptionUtils";
import { i18n } from "../services/i18nService";
import { getGlobalButtonFocusPath, getConfigForModalWithCloseButton } from "../errors/globalButtons";
import { getSdk } from "../services/sdkService";

const STARZ = "starz";
const STARZPLAY = "starzplay";

export function getParentAddOn(addOnName) {
  let parentAddOn;
  const addOnObj = getAddOnByName(addOnName); // not to check isStandAlone
  // For new acq flow, first check the additionalIn property and get the first subscription from it
  if (
    addOnObj &&
    addOnObj.configuration &&
    addOnObj.configuration["additionalIn"] &&
    addOnObj.configuration["additionalIn"].subscriptions &&
    addOnObj.configuration["additionalIn"].subscriptions.length > 0
  ) {
    parentAddOn = getAddOnByName(addOnObj.configuration["additionalIn"].subscriptions[0].subName);
  } else if (addOnObj && addOnObj.configuration["includedIn"]) {
    // check for includedIn
    parentAddOn = getAddOnByName(addOnObj.configuration["includedIn"]);
  }
  return parentAddOn;
}

export async function isSupportedDeviceForMobileLite(addOnName) {
  const addOnNameValue = addOnName === STARZ ? STARZPLAY : addOnName;
  try {
    const subsArray = await getAllActiveSubscriptionsDeepQuery();
    const allSubscriptions = (subsArray && subsArray.subscriptions) || [];
    if (allSubscriptions && allSubscriptions.length > 0) {
      let selectedSubscription = allSubscriptions.filter(arr => arr.name === addOnNameValue);
      selectedSubscription = selectedSubscription && selectedSubscription.length > 0 ? selectedSubscription[0] : null;
      const planId = selectedSubscription && selectedSubscription.paymentPlanId;
      if (planId > 0) {
        return await checkPaymentMethodByPlanId.call(this, planId);
      } else {
        // Inactive subscription
        return true;
      }
    }
  } catch (error) {
    // If Subscription call failed (We should not restrict user to playback)
    return true;
  }
  // addOnName not coming from BE (We should not restrict user to playback)
  return true;
}

async function checkPaymentMethodByPlanId(planId) {
  if (!planId || planId === 0) {
    return true; // you are allowed to play the content
  }
  // call api to get the payment Plan Info using the ID
  const paymentMethodData = await getPaymentMethodFromStore.call(this, planId);
  return isSupportedClient(paymentMethodData, planId);
}

export function isBaseSubscription(addOnName) {
  return addOnName === STARZ || addOnName === STARZPLAY;
}

// TODO: Need to update cache mechanism
export async function getPaymentPlanIdFromBilling() {
  const { stateActions } = this.props;
  const userBillingInfo = getAppState().userBilling;
  if (userBillingInfo) {
    return userBillingInfo["parentPlanId"] || userBillingInfo.paymentPlanId;
  } else {
    const isAvoidCache = false;
    const billing = await getUserPayments(isAvoidCache);
    stateActions.setUserBilling(billing);
    return billing["parentPlanId"] || billing.paymentPlanId;
  }
}

export async function getPaymentMethodFromStore(planId) {
  const { stateActions } = this.props;
  const paymentMethods = getAppState().paymentMethods;
  let selectedPaymentMethod = paymentMethods.filter(method => (method[planId] ? method : null));
  const paymentMethod = selectedPaymentMethod && selectedPaymentMethod.length > 0 && selectedPaymentMethod[0];
  if (paymentMethod) {
    return paymentMethod;
  } else {
    const paymentMethodData = await getPaymentMethod(planId);
    stateActions.setPaymentMethods(paymentMethodData);
    return paymentMethodData;
  }
}

export function isSupportedClient(paymentMethodData, planId) {
  const paymentMethodInfo = paymentMethodData[planId];
  if (!paymentMethodInfo) {
    return true;
  }

  const configuration = paymentMethodInfo && paymentMethodInfo.configuration;
  const paymentPlans = ((paymentMethodInfo && paymentMethodInfo.paymentPlans) || []).filter(
    plan => plan.esbPlanId === planId
  );
  const paymentPlan = paymentPlans.length > 0 && paymentPlans[0];
  const supportedClientKey = `${paymentPlan.planName}_supportedClients`;
  const supportedClients = configuration[supportedClientKey];
  const supportedClientsArray = supportedClients !== "" ? supportedClients?.split(",") : [];
  if (!supportedClientsArray || supportedClientsArray?.length === 0) {
    return true;
  }
  return supportedClientsArray?.length > 0 && supportedClientsArray.indexOf("TV") > -1 ? true : false; //TODO: for test make false : false
}

export async function showUnSupportedDeviceErrorPopup(closeModal) {
  const platformName = await getDeviceName();
  const { stateActions, setFocus } = this.props;
  stateActions.showGlobalModal(
    getConfigForModalWithCloseButton(
      {
        text: i18n.get("global.errors.account.unSupportedDeviceError", platformName)
      },
      closeModal
    )
  );
  setFocus(getGlobalButtonFocusPath("close"));
  return false;
}

export async function getDeviceName() {
  const platFormName = await getSdk().systemManager.device.getPlatform();
  let deviceName = "";
  switch (platFormName) {
    case "ps4":
      deviceName = i18n.get("global.errors.account.platFormName.PlayStation");
      break;
    case "tizen":
      deviceName = i18n.get("global.errors.account.platFormName.SamsungTV");
      break;
    case "vidaa":
      deviceName = i18n.get("global.errors.account.platFormName.Hisense");
      break;
    case "webos":
      deviceName = i18n.get("global.errors.account.platFormName.LG");
      break;
    default:
      deviceName = i18n.get("global.errors.account.platFormName.SamsungTV");
      break;
  }
  return deviceName;
}
